<template>
  <div class="url_web">
    <a class="url_a" href="javascript:void(0);" @click="goHome"><i class="arr"></i>{{TLang('商城首页','my')}}</a>
    <span class="line"></span>
    <span class="url_a last" href="javascript:void(0);">{{TLang('个人信息','list')}}</span>
  </div>
</template>

<script>
import { getQueryString } from '@utils';
const cityId = getQueryString('city') || 145;
export default {
  name: 'Crumb',
  methods: {
    goHome() {
      window.df_sdk_common.location.href = window.location.origin + '/mall?city=' + cityId;
    },
  },
};
</script>

<style lang="less" scoped>
.url_web {
  padding-top: 20px;
  height: 70px;
  box-sizing: border-box;
  .url_a {
    display: inline-block;
    padding: 0 15px;
    min-width: 100px;
    height: 30px;
    line-height: 28px;
    font-size: 16px;
    color: #1a4a9e;
    text-align: center;
    border: 1px solid #ededed;
    border-radius: 5px;
  }
  .url_a.last {
    background: #619ee0;
    color: #fff;
  }
  .line {
    display: inline-block;
    margin: 0 20px;
    width: 8px;
    height: 13px;
    background: url("~@assets/images/icon_bg.png") -161px -27px no-repeat;
  }
}
</style>
